module.exports = __webpack_public_path__ + "assets/img/career-office.8ef9fb3d.webp";